/**
 *
 * @param {boolean} shouldGrayscale
 */
export const grayscaleImages = shouldGrayscale => {
  const ratio = shouldGrayscale ? 1 : 0;
  const previousStyle = document.querySelector('#style-grayscale');

  if (previousStyle) {
    previousStyle.remove();
  }

  const style = Object.assign(document.createElement('style'), {
    id: 'style-grayscale',
  });

  document.head.append(style);
  style.sheet.insertRule(
    `img:not(.noGrayscaling), [class^="imageDiv-"] {filter: grayscale(${ratio})}`,
    0,
  );
};

export const setCSSVariable = (name, val) => {
  window.document.body.style.setProperty(name, val);
};

export const hex2Rgb = hex => {
  let c = [...hex.slice(1)];
  if (c.length === 3) {
    c = [c[0], c[0], c[1], c[1], c[2], c[2]];
  }
  c = `0x${c.join('')}`;
  // eslint-disable-next-line no-bitwise
  return [(c >> 16) & 255, (c >> 8) & 255, c & 255];
};

export function isBrightColor(color) {
  const rgb = hex2Rgb(color);
  // according to http://www.w3.org/TR/AERT#color-contrast
  // color brightness is determined by the following formula
  const yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  return yiq > 128;
}

export function shadeColor(color, percent) {
  let R = Number.parseInt(color.slice(1, 3), 16);
  let G = Number.parseInt(color.slice(3, 5), 16);
  let B = Number.parseInt(color.slice(5, 7), 16);
  R = Number.parseInt((R * (100 + percent)) / 100, 16);
  G = Number.parseInt((G * (100 + percent)) / 100, 16);
  B = Number.parseInt((B * (100 + percent)) / 100, 16);
  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;
  const RR = R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG = G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB = B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);
  return `#${RR}${GG}${BB}`;
}
